import React, { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import printStyles from "../../assets/css/modules/print.css";
import { Layouts } from "../../constants/Constants";
import { Paths, Urls } from "../../constants/UrlConstants";
import Contentify from "../../content/Contentify";
import Store from "../../content/Store";
import SmallFooterMenu from "./SmallFooterMenu";
import DateHelper from "../../helpers/DateHelper";
import MemberHelper from "../../helpers/MemberHelper";
import { EPDomain_ROOT } from "../../constants/EP-config";
import EPQueryParams from "../../constants/EPQueryParams";
import SocialMedia from "./SocialMedia";
import { getFooterLinks } from "./getFooterLinks";
import {
  isSalesForceLiveAgentMOLFeatureEnabled,
  isSalesForceLiveAgentHOLFeatureEnabled
} from "../../features/FeatureChecks";
import LiveAgent from "../liveChat/LiveAgent";
import linkStyles from "../../assets/css/modules/shared/link.css";

export const mapStateToFooter = (state) => {
  const currentPolicy = state.policyReducer && state.policyReducer.selectedPolicy;
  const isInternational = currentPolicy && currentPolicy.IsInternational;
  const isSaga = currentPolicy && currentPolicy.IsSaga;
  const isLapsed = currentPolicy && currentPolicy.IsLapsed;
  const layout = state.layoutReducer && state.layoutReducer.layout;
  const currentMember = MemberHelper.getCurrentLoggedInMemberFromPolicy(
    currentPolicy
  );
  const isAgeAbove18 = DateHelper.isAgeAbove18(currentMember.DateOfBirth);
  return {
    isInternational,
    isSaga,
    isLapsed,
    layout,
    footerLinks: getFooterLinks(currentPolicy, layout, isAgeAbove18),
    featureFlagEP : state.unreadMessagesReducer.featureFlagEP,
    IsInternalView: state.policyReducer &&
    state.policyReducer.policyDetails &&
    state.policyReducer.policyDetails.IsInternalView,
  };
};

export const Footer = function (props) {
  let pageArea = props.pageArea || "default";
  const [urlInbox,setstateUrlInbox] = useState(Urls.EngagementPortal[EPDomain_ROOT].messages);

const handleInboxCallback  =(childData) =>{
  setstateUrlInbox(childData );
};
  return (
    <div
      className={"footer container " + printStyles.noprint}
      role="contentinfo"
      aria-label="Footer"
    >
      <div className="row footer-bottom footer-bottom-social">
        <div className="container d-flex flex-column">
          <div className="footer-languages-bottom-container footer-rearrange hidden-lg-up">
            <SocialMedia />
          </div>
          <div className="hidden-sm-up">
            <div className="footer-links-collapsed">
              <ul>
                <SmallFooterMenu
                  FooterLinks={props.footerLinks}
                  isLapsed={props.isLapsed}
                  isInternational={props.isInternational}
                  isSaga={props.isSaga}
                  isHOL={props.layout === Layouts.HOL}
                  pageArea={pageArea}
                  featureFlagEP = {props.featureFlagEP}
                  urlInbox={urlInbox}
                  IsInternalView={props.IsInternalView}
                />
              </ul>
            </div>
          </div>
        </div>
      </div>
      <EPQueryParams url={urlInbox} updatedURL={handleInboxCallback}/>
      <div className="row footer-top hidden-xs-down">
        <div className="container">
          <section className="col-sm-12 footer-links">
            <div className="row">
              {props.footerLinks.map((footerMenu, footerMenuCtr) => {
                return (
                  <div className="col-sm-4 col-lg-3" key={footerMenuCtr}>
                    <div className="footer-link-title hidden-xs-down">
                      {footerMenu.Heading}
                    </div>
                    <ul className="footer-link-list">
                      {footerMenu.Links.map((footerLink, footerLinkCtr) => {
                        let helpLink = "";
                        if (footerLink.Link === Paths.Help) {
                          helpLink = "?area=" + pageArea;
                        }
                        if (footerLink.Link === Urls.AccessibilityUrl) {
                          return (
                            <li
                              className="footer-link-item"
                              key={footerLinkCtr}
                            >
                              <a
                                href={footerLink.Link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer-link"
                              >
                                {footerLink.Text}
                              </a>
                            </li>
                          );
                        } else if(props.featureFlagEP === true && footerLink.Link === Paths.Inbox){
                          if(props.IsInternalView)
                            {
                              
                                return (<Link to="/" className={linkStyles.disabled} onClick={ (event) => event.preventDefault() }>{footerLink.Text}</Link>);
                              
                            }
                            else{
                        return (
                        <li className="footer-link-item" key={footerLinkCtr}>
                          <a
                            href={urlInbox}
                            target="_blank"
                            rel="noopener"
                            className="footer-link"
                          >
                            {footerLink.Text}
                          </a>
                        </li>
                        );
                      }
                      } else  {
                          return (
                            <li
                              className="footer-link-item"
                              key={footerLinkCtr}
                            >
                              <Link
                                to={footerLink.Link + helpLink}
                                className="footer-link"
                              >
                                {footerLink.Text}
                              </Link>
                            </li>
                          );
                        }
                      })}
                    </ul>
                  </div>
                );
              })}
              <div className="col-sm-4 col-lg-3 hidden-md-down  footer-light-social-top-container">
                <div className="footer-languages-top-container">
                  <div className="footer-link-title">Follow Us:</div>
                  <SocialMedia />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div className="row footer-bottom footer-allow-sfla">
        <div className="container">
          <div className="footer-copyline footer-copyline-bottom">
            {!props.isInternational && !props.isSaga ? (
              <a
                href={props.content.AxaHealthAbout}
                rel="noopener noreferrer"
                target="_blank"
              >
                Information about AXA Health
              </a>
            ) : null}
            <a
              href={props.content.PrivacyPolicyUrl}
              rel="noopener noreferrer"
              target="_blank"
            >
              Privacy Policy
            </a>
            <a
              href={props.content.CookiePolicyUrl}
              rel="noopener noreferrer"
              target="_blank"
            >
              Cookie Policy
            </a>
            <div>
              © {new Date().getFullYear()} {props.content.WebAppName}, All
              Rights Reserved
            </div>
          </div>
        </div>
      </div>
      {((isSalesForceLiveAgentMOLFeatureEnabled() &&
        props.layout === Layouts.MOL) ||
        (isSalesForceLiveAgentHOLFeatureEnabled() &&
          props.layout === Layouts.HOL)) &&
      !props.isInternational ? (
        <div id={props.layout === Layouts.MOL?"CTA_live_chat_mol_floating":"CTA_live_chat_holcol_floating"}>
        <LiveAgent />
        </div>
      ) : null}
    </div>
  );
};

Footer.content = Store.Footer;

export default Contentify(connect(mapStateToFooter)(Footer));
